import { getTherapy } from '@alberta/konexi-shared';
import { Component, Input, OnChanges } from '@angular/core';
import { TherapyItem } from 'src/app/shared/models/therapy-item';

import type { Therapy } from '@alberta/konexi-shared';
@Component({
  selector: 'itl-detail-title-therapy-icon',
  templateUrl: './detail-title-therapy-icon.component.html',
  styleUrls: ['./detail-title-therapy-icon.component.scss'],
})
export class DetailTitleTherapyIconComponent implements OnChanges {
  @Input() therapyId: Therapy;
  @Input() inactive = false;
  public therapyItem: TherapyItem;

  ngOnChanges(): void {
    this.therapyItem = getTherapy(this.therapyId);
  }
}
